export const productStateReducer = (state = {loading: false, resultstatus: null, states: [], productState: null, total: 0} , action) => {
    switch (action.type) {
        case 'PRODUCT_STATE_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                states: action.payload.states || [],
                total: action.payload.total || 0
            }
        case 'PRODUCT_STATE_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                resultstatus: action.payload.message,
                productState: action.payload.productState,
                states: [...state.states, action.payload.productState],
            }
        case 'PRODUCT_STATE_EDIT_SUCCESS':
            if(action.payload.productState){
                return {
                    ...state,
                    loading: false,
                    resultstatus: action.payload.message,
                    productState: action.payload.productState,
                    states: state.states.map(state => state._id === action.payload.productState._id ? action.payload.productState : state),
                }
            }else{
                return {
                    ...state,
                    loading: false,
                    resultstatus: action.payload.message || action.payload
                }
            }
        case 'PRODUCT_STATE_RESET_RESULT':
            return {
                ...state,
                resultstatus: null
            }
        case 'PRODUCT_STATE_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'PRODUCT_STATE_ERROR':
            return {
                ...state,
                loading: false,
                resultstatus: action.payload
            }
        default:
            return state
    }
}